import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-8 bg-white" data-id="element-184">
      <div className="container mx-auto px-4" data-id="element-185">
        <div className="max-w-4xl mx-auto" data-id="element-186">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8" data-id="element-187">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a2e] mb-6 font-montserrat" data-id="element-188">
              El problema no es el celular. <br data-id="element-189" />
              <span className="text-[#F97316]" data-id="element-190">Es la falta de estructura.</span>
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-6 items-center" data-id="element-191">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-red-50 p-6 rounded-2xl border border-red-100" data-id="element-192">
              <h3 className="text-xl font-bold text-red-800 mb-4 flex items-center gap-2" data-id="element-193">
                <XCircle className="w-6 h-6" data-id="element-194" />
                Lo que no funciona
              </h3>
              <ul className="space-y-4 text-red-900/80" data-id="element-195">
                <li className="flex gap-3" data-id="element-196">
                  <span className="text-red-500 font-bold" data-id="element-197">•</span>
                  Quitar el internet abruptamente (genera tensión)
                </li>
                <li className="flex gap-3" data-id="element-198">
                  <span className="text-red-500 font-bold" data-id="element-199">•</span>
                  Ignorar la situación esperando que pase sola
                </li>
                <li className="flex gap-3" data-id="element-200">
                  <span className="text-red-500 font-bold" data-id="element-201">•</span>
                  Castigos sin explicación previa
                </li>
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-[#0ABFBC]/10 p-6 rounded-2xl border border-[#0ABFBC]/20" data-id="element-202">
              <h3 className="text-xl font-bold text-[#008f8c] mb-4 flex items-center gap-2" data-id="element-203">
                <CheckCircle2 className="w-6 h-6" data-id="element-204" />
                Lo que realmente funciona
              </h3>
              <p className="mb-4 text-[#1a1a2e]" data-id="element-205">
                Tener un plan claro y aplicable. Cuando existen límites
                definidos:
              </p>
              <ul className="space-y-3" data-id="element-206">
                {['Se reducen conflictos', 'Mejora la comunicación', 'Se recuperan momentos de conexión'].map((item, i) => <li key={i} className="flex items-center gap-3 text-[#1a1a2e] font-medium" data-id="element-207">
                    <div className="w-5 h-5 rounded-full bg-[#0ABFBC] flex items-center justify-center text-white text-xs" data-id="element-208">
                      ✓
                    </div>
                    {item}
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}